import { Box, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";
import CustomBreadCrumb from "../../../../components/breadcrumb";

import { BREADCRUMB_LEAVE } from "../../constants";
import { Container, ContainerFluid } from "../../../../common/styles";
import { useQuery } from "react-query";
import { getMyInformations } from "../../../../api/user";
import { ROLES_CODE } from "../../../../constants/roles";
import { api_holidays_list, manager_pending_leaves } from "../../api";

import { TabList } from "@fluentui/react-components";
import { useSearchParams } from "react-router-dom";
import LoaderPage from "../../../../components/loaders/LoaderPage";
import { isDelegatedToRole } from "../../../../utils/permissions";
import withAuth from "../../../../HOC/withAuth";
import withRole from "../../../../HOC/withRole";
import useTitle from "../../../../hooks/useTitle";
import LeaveTabs from "./LeaveTabs/LeaveTabs";
import { _renderTab, TABS_LEAVE, TABS_LEAVE_ARRAY } from "./utils/functions";

const Parent = () => {
    useTitle("Gestionnaire des absences");

    const [params, setParams] = useSearchParams();
    const [_, setCleanParams] = useSearchParams();

    const [activeTab, setActiveTab] = React.useState(
        TABS_LEAVE_ARRAY[params.get("tab")] ?? TABS_LEAVE.absences
    );

    // holidays list
    const { data: holiday_list, isLoading: isLoadingHolidayList } = useQuery(
        ["holidays_list"],
        () => api_holidays_list()
    );

    const { data: myInfo } = useQuery(["getMyInformations"], () =>
        getMyInformations()
    );

    const {
        data: teamBadge,
        isLoading: isLoadingTeamBadge,
        isFetching: isFetchingTeamBadge,
    } = useQuery(["teamBadge"], () => manager_pending_leaves());

    if (isLoadingHolidayList) {
        return <LoaderPage />;
    }

    const Roles_management = myInfo?.user?.roles;
    const isManager = Roles_management?.map((el) => el?.code).includes(
        ROLES_CODE?.manager
    );
    const isRH = Roles_management?.map((el) => el?.code).includes(
        ROLES_CODE?.hr
    );
    // voir s'il est delegue
    const isDelegatedForLeave = isDelegatedToRole(["leave"]);
    const isFetchingCounterBadge = isLoadingTeamBadge || isFetchingTeamBadge;
    return (
        <ContainerFluid styles={{ minHeight: "100vh" }} fill column>
            <CustomBreadCrumb navList={BREADCRUMB_LEAVE} />
            {/* tabs */}
            <Box
                style={{
                    margin: "8px 0px 0px 0px",
                }}
            >
                <Container>
                    <LeaveTabs
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        isManager={isManager}
                        isDelegatedForLeave={isDelegatedForLeave}
                        setCleanParams={setCleanParams}
                        isFetchingCounterBadge={isFetchingCounterBadge}
                        teamBadge={teamBadge}
                        isRH={isRH}
                    />
                </Container>
            </Box>
            {/* render depending current tab */}
            <Flex
                style={{
                    backgroundColor: "#f5f5f5",
                    flex: 1,
                }}
            >
                {_renderTab(activeTab, isRH, isManager, holiday_list)}
            </Flex>
        </ContainerFluid>
    );
};

export default withAuth(withRole([ROLES_CODE.employee])(Parent));

export const TabListStyle = styled(TabList)`
    overflow-x: scroll;
    width: 100%;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;

export const TeamBadge = styled(Text)`
    background-color: #ffb900;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: white;
    text-align: center;
    margin-left: 5px;
`;
